<div *ngIf="content.title">
  <aura-partners [content]="content" (redirect)="redirect($event)"></aura-partners>
</div>
